import script from "./ServicesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServicesView.vue?vue&type=script&setup=true&lang=ts"

import "./ServicesView.vue?vue&type=style&index=0&id=71a2c55a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a2c55a"]])

export default __exports__